import { iconSizes } from "../theming/themes/common/iconSizes";
import { IconSizeVariants, IconSizeProps } from "../theming/types";

const useIconSize = (size: IconSizeVariants): IconSizeProps =>
  iconSizes[size as IconSizeVariants];

export default useIconSize;
